import { ChangeEvent, useCallback } from 'react';
import { DropdownItem, Select, Selected, StackItem, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { useCityLedgerPagination } from '../../../context/CityLedgerFilterContext';

const PAGINATION_SIZES = [10, 25, 50, 75, 100] as const;
type PageSize = (typeof PAGINATION_SIZES)[number];

interface PaginationSizeElementProps {
    totalRowCount: number;
}

export const PaginationSizeElement = ({ totalRowCount }: PaginationSizeElementProps) => {
    const { pagination, setPagination } = useCityLedgerPagination();

    const handlePageSizeChange = useCallback(
        (_e: ChangeEvent, newPageSizeValue: Selected) => {
            const newPageSize = parseInt(newPageSizeValue as string, 10);
            if (PAGINATION_SIZES.includes(newPageSize as PageSize)) {
                setPagination((prev) => ({
                    ...prev,
                    pageSize: newPageSize,
                    pageIndex: 0,
                }));
            }
        },
        [setPagination]
    );

    if (!totalRowCount) return null;

    const paginationText = (
        <Typography textStyle="bodyLarge" as="span">
            {lt('PaginationItems', { items: totalRowCount })}
        </Typography>
    );

    return pagination.pageSize < totalRowCount ? (
        <>
            <Typography textStyle="bodyLarge" as="span">
                {lt('Show')}
            </Typography>
            <StackItem minWidth="80px">
                <Select
                    name="select-page-size"
                    selected={pagination.pageSize}
                    onChange={handlePageSizeChange}
                    size="small"
                    sizeToAnchor={false}
                >
                    {PAGINATION_SIZES.map((pageSizeOption) => (
                        <DropdownItem label={pageSizeOption} value={pageSizeOption} key={pageSizeOption} />
                    ))}
                </Select>
            </StackItem>
            {paginationText}
        </>
    ) : (
        paginationText
    );
};
